import { ArrowDownToLine, ArrowLeftRight, ArrowUpFromLine, TrendingUp } from 'lucide-react'
import { Modal } from './modal'
import { TokenIcon } from './holdings-table'
import { formatTokenAmount, formatUsd } from '@/lib/format'
import type { PickedToken } from '@/lib/picked-token'

/** Wallet actions: phones stack the icon over the label so neither can shrink; wider screens keep them inline. */
export const ACTION_BTN = 'btn flex-col gap-1 px-1 py-2 text-xs sm:flex-row sm:gap-2 sm:px-4 sm:py-2.5 sm:text-base'
export const ACTION_ICON = 'size-5 shrink-0 sm:size-4'

export type TokenAction = 'swap' | 'deposit' | 'withdraw' | 'strategy'

/**
 * What a tapped holdings row offers: the same three buttons as the wallet
 * header plus Strategy (John, Oct 31 2026), with the token carried into the flow.
 */
export function TokenActions({ token, onClose, onAction }: { token: PickedToken | null; onClose: () => void; onAction: (action: TokenAction, token: PickedToken) => void }) {
  const balance = token?.balance ?? 0
  const value = token?.priceUsd !== undefined ? balance * token.priceUsd : undefined
  return (
    <Modal
      open={token !== null}
      onClose={onClose}
      width="sm"
      title={
        token ? (
          <span className="flex items-center gap-2">
            <TokenIcon symbol={token.symbol} imageUrl={token.imageUrl} />
            {token.symbol}
          </span>
        ) : (
          ''
        )
      }
    >
      {token ? (
        <div className="flex flex-col gap-4">
          <div className="flex items-baseline justify-between text-sm">
            <span className="text-muted">Balance</span>
            <span className="tabular-nums">
              {formatTokenAmount(balance, token.symbol)} {token.symbol}
              {value !== undefined ? <span className="ml-2 text-muted">{formatUsd(value)}</span> : null}
            </span>
          </div>
          {/* two by two: four labelled buttons do not fit across the small dialog (John, Oct 31 2026) */}
          <div className="grid grid-cols-2 gap-2">
            <button type="button" className={`${ACTION_BTN} btn-primary`} onClick={() => onAction('swap', token)}>
              <ArrowLeftRight className={ACTION_ICON} /> Swap
            </button>
            <button type="button" className={`${ACTION_BTN} btn-secondary`} onClick={() => onAction('deposit', token)}>
              <ArrowDownToLine className={ACTION_ICON} /> Deposit
            </button>
            <button type="button" className={`${ACTION_BTN} btn-secondary`} disabled={balance <= 0} onClick={() => onAction('withdraw', token)}>
              <ArrowUpFromLine className={ACTION_ICON} /> Withdraw
            </button>
            {/* a strategy is on a token, never on SOL itself */}
            <button type="button" className={`${ACTION_BTN} btn-secondary`} disabled={token.isNative} onClick={() => onAction('strategy', token)}>
              <TrendingUp className={ACTION_ICON} /> Strategy
            </button>
          </div>
        </div>
      ) : null}
    </Modal>
  )
}
